/**
 * Creature collection helpers (pure): filtering for the world map / creature book.
 */
import type { PathId } from '../content/model';
import type { CreatureMeta } from './types';

/** Creatures of one profile (newest first), optionally only those living in `worldId`. */
export function creaturesFor(list: readonly CreatureMeta[], profileId: string | null | undefined, worldId?: PathId): CreatureMeta[] {
  return list
    .filter((c) => (!profileId || c.profileId === profileId) && (!worldId || c.worldId === worldId))
    .slice()
    .sort((a, b) => (a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
}

/** Count per world (creature book tabs, map badges). */
export function creatureCounts(list: readonly CreatureMeta[], profileId: string | null | undefined): Partial<Record<PathId, number>> {
  const out: Partial<Record<PathId, number>> = {};
  for (const c of list) if (!profileId || c.profileId === profileId) out[c.worldId] = (out[c.worldId] ?? 0) + 1;
  return out;
}

/** Max creatures kept per profile (oldest are dropped from the device first). */
export const MAX_CREATURES_PER_PROFILE = 120;
